export default __webpack_public_path__ + "static/media/Logo.7dea7ad8.png";